import {
  Button,
  Modal,
  Form,
  Input,
  Typography,
  message,
  Select,
  DatePicker,
  Row,
  Col,
  Drawer,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
  useRef
} from "react";
import {
  EditOutlined,
  BankOutlined,
  LoadingOutlined,
  DeleteOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";
import commonFn from "@/utils/commonFn";
const AddModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [insurance, setInsurance] = useState([]);
  const [statementFiles, setStatementFiles] = useState([]);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [filePaths, setFilePaths] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const allFiles = [...insurance, ...statementFiles];
  const [propId, setPropId] = useState([]);
  const [propLoading, setPropLoading] = useState(false);
  const [insuranceTypeLoading, setInsuranceTypeLoading] = useState(false);
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState([]);
  const [anetList, setAnetList] = useState([]);
  const [agentLoading, setAgentLoading] = useState(false);
  const [buildingLoadingMap, setBuildingLoadingMap] = useState({});
  const [isAmountManual, setIsAmountManual] = useState(false);
  const buildingList = Form.useWatch("buildingList", form);
  const [glAcctOptionsMap, setGlAcctOptionsMap] = useState({});
  const { onSuccess } = props;
  const [uploadOpen, setUploadOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
 const [paymentFileList, setPaymentFileList] = useState([]);
  const columnStyle = {
    border: "1px solid #f0f0f0",
    padding: 20,
    borderRadius: 8,
    background: "#fafafa",
    minHeight: "100%",
  };

useImperativeHandle(ref, () => ({
  setModelAdd: async (record = null) => {
    form.resetFields();
    setInsurance([]);
    setStatementFiles([]);
    setPreviewIndex(0);
    setFilePaths([]);
    setVisible(true);
    setCurrentRecord(record);
    
    console.log('record', record);
    
    if (record) {
      if (anetList.length === 0) {
        await getAgentTypeList();
      }
  
      // console.log('设置的表单值:', formValues);
      // form.setFieldsValue(formValues);
    }
  },
}));
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        // propertyList: [{}],
        buildingList: [{}],
      });
    }
  }, [visible]);

  const syncFileList = (files = []) => {
    setFilePaths(files);
  };

  useEffect(() => {
    const normalizedFiles = (filePaths || []).map((item) => ({
      ...item,
      path: item?.path || "",
      fileName: item?.fileName || item?.name || "",
      status: item?.status ?? 1,
    }));

    setStatementFiles(normalizedFiles);
    setPreviewIndex(normalizedFiles.length ? 0 : -1);
    form.setFieldsValue({
      fileList: normalizedFiles,
      new_insurance: filePaths,
    });
  }, [filePaths, form]);

    const parseAmountValue = (value) => {
    if (value === undefined || value === null || value === "") return 0;
    const normalizedValue = String(value).replace(/,/g, "").trim();
    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };

  const getAgentTypeList = async () => {
    if (anetList.length > 0 || agentLoading) return;

    setAgentLoading(true);

    try {
      const res = await http.get(api.getAgentType);
      const data = res?.data || res;

      const list = (data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));

      setAnetList(list);
    } catch (err) {
      message.error("Request Error");
    } finally {
      setAgentLoading(false);
    }
  };
const uploadByBankApi = async (file, fieldType) => {
  const formData1 = new FormData();
  formData1.append("files", file.originFileObj);
  
  const formData2 = new FormData();
  formData2.append("files", file.originFileObj);
  formData2.append("type", "new_insurance");
  
  try {
    const [res1, res2] = await Promise.all([
      http.post(api.getInsuranceFile, formData1, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
      http.post(api.getInsurancePaymentFile, formData2, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
    ]);
    
    // 返回两个接口的结果
    return {
      insuranceFile: res1.code === "1" ? res1.data[0] : null,
      paymentFile: res2.code === "1" ? res2.data[0] : null,
    };
    
  } catch (error) {
    console.error("Upload error:", error);
    throw new Error(error?.message || "Upload failed");
  }
};
  // 上传文件
  // const addOldFn = async (files) => {
  //   setBtnDisabled(true);
  //   setUploadLoading(true);
  //   try {
  //     const currentFile = files?.[files.length - 1];
  //     if (!currentFile?.originFileObj) {
  //       return { flag: false };
  //     }

  //     const uploadedFile = await uploadByBankApi(currentFile, "new_insurance");
  //     const normalizedFile = {
  //       ...uploadedFile,
  //       uid: uploadedFile?.customId || currentFile.uid,
  //       //  type: "new_insurance",
  //       name:
  //         uploadedFile?.fileDateName ||
  //         uploadedFile?.fileName ||
  //         currentFile.name,
  //       fileName:
  //         uploadedFile?.fileDateName ||
  //         uploadedFile?.fileName ||
  //         currentFile.name,
  //       allPath:
  //         uploadedFile?.url ||
  //         uploadedFile?.allPath ||
  //         (currentFile.originFileObj &&
  //           URL.createObjectURL(currentFile.originFileObj)),
  //       originFileObj: currentFile.originFileObj,
  //       size: currentFile.size,
  //     };

  //     return {
  //       flag: true,
  //       fileData: normalizedFile,
  //     };
  //   } catch (error) {
  //     console.error(error);
  //     message.error(error?.message || "Upload failed");
  //     return { flag: false };
  //   } finally {
  //     setBtnDisabled(false);
  //     setUploadLoading(false);
  //   }
  // };
const addOldFn = async (files) => {
  setBtnDisabled(true);
  setUploadLoading(true);
  try {
    const currentFile = files?.[files.length - 1];
    if (!currentFile?.originFileObj) {
      return { flag: false };
    }
    const result = await uploadByBankApi(currentFile, "new_insurance");
    
    const commonUid = currentFile.uid;
    // 处理 insuranceFile（filePaths 使用）
    const uploadedFile = result.insuranceFile;
    const normalizedFile = {
      ...uploadedFile,
      uid: commonUid,  
      name: uploadedFile?.fileDateName || uploadedFile?.fileName || currentFile.name,
      fileName: uploadedFile?.fileDateName || uploadedFile?.fileName || currentFile.name,
      allPath: uploadedFile?.url || uploadedFile?.allPath || 
        (currentFile.originFileObj && URL.createObjectURL(currentFile.originFileObj)),
      originFileObj: currentFile.originFileObj,
      size: currentFile.size,
    };
    // 处理 paymentFile（paymentFileList 使用）
    const paymentFile = result.paymentFile;
    const normalizedPaymentFile = {
      ...paymentFile,
      uid: commonUid,  
      name: paymentFile?.fileDateName || paymentFile?.fileName || currentFile.name,
      fileName: paymentFile?.fileDateName || paymentFile?.fileName || currentFile.name,
      allPath: paymentFile?.url || paymentFile?.allPath || 
        (currentFile.originFileObj && URL.createObjectURL(currentFile.originFileObj)),
      originFileObj: currentFile.originFileObj,
      size: currentFile.size,
    };
    
    setPaymentFileList(prev => [...prev, normalizedPaymentFile]);

    return {
      flag: true,
      fileData: normalizedFile,
    };
  } catch (error) {
    console.error(error);
    message.error(error?.message || "Upload failed");
    return { flag: false };
  } finally {
    setBtnDisabled(false);
    setUploadLoading(false);
  }
};
  const deleteOldFn = async (file) => {
    return true;
  };

const deleteBase64FileFn = async (file) => {
  const uid = file?.uid;
  // 从 filePaths 中删除
  const list = filePaths.filter((item) => item?.uid !== uid);
  // 从 paymentFileList 中删除
  setPaymentFileList(prev => prev.filter((item) => item?.uid !== uid));
  return list;
};
  //点击select时候 获取prop数据
    const propAllRef = useRef([]);
    const propIdFun = async (content = "") => {
    try {
      setPropLoading(true);

      const response = await http.get(api.propSearch, {
        params: { content },
      });

      const data = response?.data || [];

      const formattedData = data.map((item) => ({
        value: item.propId,
        label: item.propName,
        prop: item.prop,
      }));

      setPropId(formattedData);
    } catch (err) {
      console.log(err);
    } finally {
      setPropLoading(false);
    }
  };
  const handleDropdownOpen = (open) => {
    if (open && propId.length === 0) {
      propIdFun();
    }
  };
  const searchTimer = useRef();
  const onTypeSearch = (value) => {
    clearTimeout(searchTimer.current);

    searchTimer.current = setTimeout(() => {
      propIdFun(value);
    }, 300);
  };

  const getPropDetailsFun = async (propId, rowName, rowKey = rowName) => {
    if (!propId) return;

    setBuildingLoadingMap((prev) => ({
      ...prev,
      [rowKey]: true,
    }));

    try {
      const [detailRes, glAcctRes] = await Promise.all([
        http.get(api.getPropDetails, { params: { propId } }),
        http.get(api.getInstanceByGlAcct, { params: { propId } }),
      ]);

      const detailData = detailRes?.data;
      const glAcctData = glAcctRes?.data;

      /** ===== 第一个接口：property详情 ===== */
      if (detailData) {
        form.setFieldValue(
          ["buildingList", rowName, "units"],
          detailData.units || "",
        );

        form.setFieldValue(
          ["buildingList", rowName, "totalUnits"],
          detailData.units || "",
        );

        // form.setFieldValue(
        //   ["buildingList", rowName, "state"],
        //   detailData.street || "",
        // );

        // form.setFieldValue(
        //   ["buildingList", rowName, "county"],
        //   detailData.county || "",
        // );

        // form.setFieldValue(
        //   ["buildingList", rowName, "liabilityDeductible"],
        //   detailData.liabilityDeductible || "",
        // );
        //    form.setFieldValue(
        //   ["buildingList", rowName, "liabilityLimit"],
        //   detailData.liabilityLimit || "",
        // );

           form.setFieldValue(
          ["buildingList", rowName, "trustName"],
          detailData.trustName || detailData.owner || "",
        );
        form.setFieldValue(
          ["buildingList", rowName, "managementCompany"],
          detailData.companyName || "",
        );

        form.setFieldValue(
          ["buildingList", rowName, "propName"],
          detailData.propName || "",
        );

        form.setFieldValue(
          ["buildingList", rowName, "prop"],
          detailData.prop || "",
        );
      }
      /** ===== GLAcct select ===== */
      if (glAcctData) {
        const options = (glAcctData || []).map((item) => ({
          label: item.glAcctTitle,
          value: item.glChartId,
        }));

        setGlAcctOptionsMap((prev) => ({
          ...prev,
          [rowKey]: options,
        }));

      
      }
    } catch (err) {
      message.error("Failed to fetch property details");
    } finally {
      setBuildingLoadingMap((prev) => ({
        ...prev,
        [rowKey]: false,
      }));
    }
  };

  // 提交
  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const {
        expirationDate,
        effectiveDate,
        policyNumber,
        // insuranceType,
        amount,
        numberOfProperties,
        numberOfBuildings,
        carrier,
        agent,
        payee,
        buildingList = [],
      } = values;
          for (let i = 0; i < buildingList.length; i++) {
      const item = buildingList[i];

      if (!item?.amount) {
        message.error(`Building List ${i + 1}: Amount is required`);
         form.scrollToField(["buildingList", i, "amount"]);
        setLoading(false);
        return;
      }

      if (!item?.propId) {
        message.error(`Building List ${i + 1}: Property is required`);
         form.scrollToField(["buildingList", i, "propId"]);
        setLoading(false);
        return;
      }
    }
      const formattedBuildingList = buildingList.map((item) => {
        const fallbackProp =
          propId.find((opt) => String(opt.value) === String(item.propId))
            ?.prop || "";
        return {
          // amount: item.amount,
          // policyUnits: item.policyUnits,
          amount: parseAmountValue(item.amount),
          prop: item.prop || fallbackProp,
          propId: item.propId,
          // totalUnits: item.totalUnits || item.units || "",
          // addressCityStateZip: item.addressCityStateZip,
          glChartId: item.glChartId,
          liabilityDeductible:item.liabilityDeductible,
          liabilityLimit:item.liabilityLimit,
        };
      });
      const fileList = form.getFieldValue("fileList") || [];
      const insuranceFileList = fileList.map(({ path, fileName, status }) => ({
        path,
        fileName,
        status: status ?? 1,
      }));
      const insurancePaymentFileList = paymentFileList.map((item) => ({
      ext: item.ext || item.name?.split('.').pop() || '',
      path: item.path || item.allPath || '',
      name: item.name || item.fileName || '',
      uuid: item.uuid || item.uid || '',
      type: "new_insurance",
    }));
      const params = {
        expirationDate: expirationDate?.format("YYYY-MM-DD"),
        effectiveDate: effectiveDate?.format("YYYY-MM-DD"),
        policyNumber,
        // insuranceType,
        amount,
        numberOfProperties,
        numberOfBuildings,
        carrier,
        // vendorId: agent,
         agentVendorId:agent,
         payeeVendorId:payee,
        buildingList: formattedBuildingList,
        insuranceFileList,
        insurancePaymentFileList,
        //  foreignId: currentRecord?.id, 
      };
   
      const res = await http.post(api.getInsuranceAdd, params);

      if (res?.code === "1") {
        message.success("Insurance created successfully.");
        setVisible(false);
        form.resetFields();
        setInsurance([]);
        setStatementFiles([]);
        setPreviewIndex(0);
        setFilePaths([]);
      setPaymentFileList([]);
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      if (!err?.errorFields) {
        message.error("Request failed, please try again");
      }
    } finally {
      setLoading(false);
    }
  };


const debounceRef = useRef();
const prevRef = useRef({
  amount: "0.00",
  numberOfProperties: 0,
  numberOfBuildings: 0,
});

useEffect(() => {
  if (!buildingList || !Array.isArray(buildingList)) return;

  clearTimeout(debounceRef.current);

  debounceRef.current = setTimeout(() => {
    let totalAmount = 0;
    const uniquePropIds = new Set();

    for (let i = 0; i < buildingList.length; i++) {
      const item = buildingList[i];

      const val = parseAmountValue(item?.amount);
      if (Number.isFinite(val)) {
        totalAmount += val;
      }

      if (item?.propId) {
        uniquePropIds.add(item.propId);
      }
    }

    const safeTotal = Number.isFinite(totalAmount) ? totalAmount : 0;

   
    const next = {
      amount: safeTotal.toFixed(2),
      numberOfProperties: uniquePropIds.size,
      numberOfBuildings: buildingList.length,
    };

    const prev = prevRef.current;

    const isSame =
      prev.amount === next.amount &&
      prev.numberOfProperties === next.numberOfProperties &&
      prev.numberOfBuildings === next.numberOfBuildings;

    if (!isSame) {
      prevRef.current = next;

     
      form.setFieldsValue({
        amount: next.amount,
        numberOfProperties: next.numberOfProperties,
        numberOfBuildings: next.numberOfBuildings,
      });
    }
  }, 120);

  return () => clearTimeout(debounceRef.current);
}, [buildingList]);

  return (
    <Modal
      title={
        <Row justify="start" align="middle" className="model_title">
          <Col>
            <EditOutlined className="model_title_mr10" />
          </Col>
          <Col>
            <Typography.Title level={4} className="mg">
              NEW POLICY
            </Typography.Title>
          </Col>
        </Row>
      }
      width="95%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setInsurance([]);
        setStatementFiles([]);
        setPreviewIndex(0);
        setFilePaths([]);
      setPaymentFileList([]);
      }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setInsurance([]);
              setStatementFiles([]);
              setPreviewIndex(0);
              setFilePaths([]);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            loading={loading || uploadLoading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }styles={{
    body: {
      minHeight: '60vh',     
      maxHeight: '80vh',   
      overflowY: 'auto',  
    }
  }}
    >
      <Row>
        <div className="model_top" style={{ width: "100%" }}>
          <Form
            form={form}
  
            name="createBankForm"
            layout="horizontal"
            labelCol={{ flex: "120px" }}
            wrapperCol={{ flex: 1 }}
            style={{ width: "100%" }}
            onFinish={onFinish}
            initialValues={{
              buildingList: [
                {
                  amount: "",
                  policyUnits: "",
                  propId: null,
                  totalUnits: "",
                  // State: "",
                  // county: "",
                  // ownership: "",
                  liabilityDeductible:"",
                  liabilityLimit:"",
                  trustName:"",
                  // managementCompany: "",
                },
              ],
            }}
          >
            <Row gutter={24} style={{ width: "100%", margin: 0 }}>
              {/* Insurance Detail */}
              <Col span={4}>
                <div style={columnStyle}>
                  <div className="modal-section-title">
                    <BankOutlined /> Insurance Detail
                  </div>
                  <Form.Item
                    name="expirationDate"
                    label="Expiration Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker style={{ width: "100%" }}   placeholder="YYYY-MM-DD" />
                  </Form.Item>
                  <Form.Item
                    name="effectiveDate"
                    label="Effective Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker style={{ width: "100%" }}   placeholder="YYYY-MM-DD" />
                  </Form.Item>
                  <Form.Item
                    name="policyNumber"
                    label="Policy Number"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Policy Number" />
                  </Form.Item>
                   <Form.Item
                    name="carrier"
                    label="Carrier"
                    rules={[{ required: true }]}
                    
                  >
                    <Input placeholder="carrier"  />
                  </Form.Item>
                  <Form.Item
                    name="agent"
                    label="Agent"
                    rules={[{ required: true }]}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                  <Select
                   style={{ width: "100%" }}
                  
                    popupMatchSelectWidth={false}
                    placeholder="Please select Payee"
                    options={anetList}
                      loading={agentLoading}
                      showSearch
                       optionFilterProp="label"
                       onDropdownVisibleChange={(open) =>
                      open && getAgentTypeList()
                     }/>
                  </Form.Item>
                   <Form.Item
                    name="payee"
                    label="Payee"
                    rules={[{ required: true }]}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                  <Select
                   style={{ width: "100%" }}
                 
                    popupMatchSelectWidth={false}
                    placeholder="Please select Payee"
                    options={anetList}
                      loading={agentLoading}
                      showSearch
                       optionFilterProp="label"
                       onDropdownVisibleChange={(open) =>
                      open && getAgentTypeList()
                     }/>
                  </Form.Item>

                  <Form.Item
                    name="amount"
                    label="Amount"
                    rules={[{ required: true }]}
                  >
                  <Input prefix="$" disabled />
                  </Form.Item>

                  <Form.Item
                    name="numberOfProperties"
                    label="# of Prop"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Number Of Properties" disabled />
                  </Form.Item>
            
          
                </div>
              </Col>
              {/* Building List */}
              <Col span={20}>
                <div style={columnStyle}>
                  <Form.List name="buildingList">
                    {(fields, { add, remove }) => (
                      <>
                        {/* 标题 */}
                        <Row
                          justify="space-between"
                          align="middle"
                          style={{ marginBottom: 16 }}
                        >
                          <div className="modal-section-title">
                            Building List
                          </div>
                        <Button
                    type="primary"
                    onClick={() => setUploadOpen(true)}
                    style={{ marginBottom: 12 }}
                    icon={<CloudUploadOutlined />}
                  >
                    Upload
                  </Button>
                        </Row>
                        {/* 表头 */}
                        <Row
                          gutter={6}
                          style={{ marginBottom: 8, fontWeight: 500 }}
                        >
                          <Col span={2}><span style={{ color: "red" }}>*</span> Amount</Col>
                          <Col span={6}> <span style={{ color: "red" }}>*</span> Property</Col>
                          <Col span={3}>GL / Insure Type</Col>
                          <Col span={4}>Deductible</Col>
                          <Col span={4}>Limit</Col>
                          <Col span={4}>Entity</Col>
                          {/* <Col span={3}>Management</Col>     */}
                          <Col span={1}>Delete‌</Col>
                        </Row>

                        {/* 数据行 */}
                        {fields.map((field) => {
                          const rowLoading = buildingLoadingMap[field.key];

                          return (
                            <Row
                              key={field.key}
                              gutter={6}
                              align="middle"
                              style={{ marginBottom: 8 }}
                            >
                              <Col span={2}>
                                <Form.Item
                                  name={[field.name, "amount"]}
                                  noStyle
                                  getValueFromEvent={(e) =>
                                    commonFn.inputAmountFormat(
                                      e?.target?.value,
                                      true,
                                      true,
                                    )
                                  }
                                  getValueProps={(value) => ({
                                    value: commonFn.inputAmountFormat(
                                      value,
                                      false,
                                      true,
                                    ),
                                  })}
                                >
                                  <Input prefix="$" />
                                </Form.Item>
                              </Col>

                            <Col span={6}>
                                <Form.Item
                                  name={[field.name, "propId"]}
                                  noStyle
                                >
                                  <Select
                                    options={propId}
                                    loading={propLoading}
                                    showSearch
                                    filterOption={false}
                                     onSearch={onTypeSearch}
                                         onClear={() => {
                                        setPropId(propAllRef.current);
                                        // 清空相关字段
                                        form.setFieldValue([ "buildingList", field.name, "propId", ], undefined,);
                                        form.setFieldValue(["buildingList", field.name,"propName",], undefined,);
                                        form.setFieldValue(["buildingList",field.name,"glChartId",],undefined,);
                                        form.setFieldValue(["buildingList", field.name,"glAcctTitle", ], undefined,);
                                        form.setFieldValue( ["buildingList", field.name, "trustName",],undefined,);}}
                                     filterOption={(inputValue, option) =>
                                      option?.label?.toLowerCase().includes(inputValue.toLowerCase()) }
                                    onDropdownVisibleChange={handleDropdownOpen}
                                    onChange={(value, option) => {
                                      const selectedProp =
                                        option?.prop ||
                                        propId.find(
                                          (item) =>
                                            String(item.value) ===
                                            String(value),
                                        )?.prop ||
                                        "";
                                      form.setFieldValue(
                                        ["buildingList", field.name, "units"],
                                        "",
                                      );
                                      form.setFieldValue(
                                        [
                                          "buildingList",
                                          field.name,
                                          "totalUnits",
                                        ],
                                        "",
                                      );
                                      form.setFieldValue(
                                        ["buildingList", field.name, "state"],
                                        "",
                                      );
                                      form.setFieldValue(
                                        ["buildingList", field.name, "county"],
                                        "",
                                      );
                                      form.setFieldValue(
                                        [
                                          "buildingList",
                                          field.name,
                                          "trustName",
                                        ],
                                        "",
                                      );
                                      // form.setFieldValue(
                                      //   [
                                      //     "buildingList",
                                      //     field.name,
                                      //     "managementCompany",
                                      //   ],
                                      //   "",
                                      // );
                                      form.setFieldValue(
                                        [
                                          "buildingList",
                                          field.name,
                                          "glChartId",
                                        ],
                                        "",
                                      );
                               
                                      getPropDetailsFun(
                                        value,
                                        field.name,
                                        field.key,
                                      );
                                    }}
                                    style={{ width: "100%" }}
                                    allowClear
                                    placeholder="Select property"
                                  />
                                </Form.Item>
                              </Col>   

                                 <Col span={3}>
                                <Form.Item
                                  name={[field.name, "glChartId"]}
                                noStyle
                                >
                                  <Select
                                    placeholder="Select GL Account"
                                    options={glAcctOptionsMap[field.key] || []}
                                    loading={buildingLoadingMap[field.key]}
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              </Col>
                           
                              <Col span={4}>
                                <Form.Item
                                  name={[field.name, "liabilityDeductible"]}
                                 noStyle
                                >
                                  <Input placeholder="Deductible"/>
                                </Form.Item>
                              </Col>

                                  <Col span={4}>
                                <Form.Item
                                  name={[field.name, "liabilityLimit"]}
                                  noStyle
                                >
                                  <Input  placeholder="Limit" />
                                </Form.Item>
                              </Col>


                              <Col span={4}>
                                <Form.Item
                                  name={[field.name, "trustName"]} noStyle
                                >
                                  <Input
                                    readOnly
                                    title={
                                      form.getFieldValue([
                                        "buildingList",
                                        field.name,
                                        "trustName",
                                      ]) || ""
                                    }
                                    suffix={
                                      rowLoading ? (
                                        <LoadingOutlined spin />
                                      ) : null
                                    }
                                    placeholder="Auto"
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={1}>
                                {fields.length > 1 && (
                                  <Button
                                    type="text"
                                    danger
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={() => remove(field.name)}
                                    style={{ padding: "4px" }}
                                  />
                                )}
                              </Col>
                            </Row>
                          );
                        })}

                        <Button
                          type="dashed"
                          block
                          style={{ marginTop: 12 }}
                          onClick={() => add({})}
                        >
                          + Add Building
                        </Button>
                      </>
                    )}
                  </Form.List>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </Row>
      <Drawer
        title="Upload PDF / Image"
        placement="right"
        width="40%"
        open={uploadOpen}
        onClose={() => {
          if (uploadLoading) return; // 上传中禁止关闭
          setUploadOpen(false);
        }}
        maskClosable={false||!uploadLoading} 
        closable={!uploadLoading} // 
        destroyOnClose={false}
      >
        <div style={{ margin: 20 }}>
          <div className="uploadText">
            Uploaded files only support JPG, PNG or PDF.
          </div>

          <div style={{ marginTop: 20 }}>
            <Form.Item name="new_insurance" noStyle>
              <CustomUploadNewBank
                customConfig={{
                  uploadButtonStyle: {
                    top: "20px",
                    right: "20px",
                  },
                  pdfHeight: "80vh",
                  fileFullName: "name",
                  notMultiple: true,
                  accept: ".jpg, .jpeg, .png, .pdf",
                  status: "add",
                  deleteOldFn,
                  deleteBase64FileFn,
                  addOldFn,
                }}
                setFilePaths={syncFileList}
                filePaths={filePaths}
                setBtnDisabled={setBtnDisabled}
                btnDisabled={btnDisabled}
              />
            </Form.Item>

            <Form.Item name="fileList" hidden />
          </div>
        </div>
      </Drawer>
    </Modal>
  );
});
export default AddModal;
